import { useState } from 'react';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import { useNavigateToRoute } from '../../../../../shared/hooks/use-navigate-to-route/use-navigate-to-route.hook';
import { ReactComponent as LogoutIcon } from '../../../assets/icons/logout-icon/logout.svg';
import { accountSettings } from '../../../utils/routes/routes.util';
import AppBar from '../AppBar';
import Avatar from '../Avatar';
import Box from '../Box';
import Container from '../Container';
import IconButton from '../IconButton';
import Menu from '../Menu/Menu';
import MenuItem from '../MenuItem/MenuItem';
import Toolbar from '../ToolBar';
import Tooltip from '../Tooltip';
import Typography from '../Typography';
import { useGetMandantConfig } from './hooks/use-get-mandant-config/use-get-mandant-config.hook';
import { useLogo } from './hooks/use-logo/use-logo.hook';
import { useOnSelectMandant } from './hooks/use-on-select-mandant/use-on-select-mandant.hook';
import { useToggleUserMenu } from './hooks/use-toggle-user-menu/use-toggle-user-menu.hook';

const TopBar = () => {
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);

  const { mandants, activeMandantId, mainLogo } = useGetMandantConfig();

  const onUserMenuOpen = useToggleUserMenu(setAnchorElUser);

  const onUserMenuClose = useToggleUserMenu(setAnchorElUser, true);

  const Logo = useLogo();
  const navigateToAllApps = useNavigateToRoute('/appstore/all-apps');

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: theme => theme.palette.appWhite.main,
          boxShadow: 'none',
          borderBottom: 1.44,
          borderColor: theme => theme.palette.appGrey.greyPrimary,
        }}
      >
        <Container maxWidth={false}>
          <Toolbar
            disableGutters
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              minHeight: '96px !important',
              backgroundColor: theme => theme.palette.appWhite.main,
            }}
          >
            <Box
              sx={{
                mr: 2,
                lineHeight: 0,
                cursor: 'pointer',
              }}
              onClick={navigateToAllApps}
            >
              {Logo}
            </Box>

            <Box
              sx={{
                flexGrow: 0,
              }}
            >
              <Tooltip title="Open settings">
                <>
                  <IconButton
                    disableRipple
                    onClick={onUserMenuOpen}
                    sx={{
                      p: 0,
                    }}
                  >
                    {/* TODO - add src and alt with user details */}
                    <Avatar
                      sx={{
                        borderRadius: 'unset',
                        img: {
                          height: 'auto',
                        },
                      }}
                      {...(mainLogo && {
                        src: `data:image/png;base64, ${mainLogo}`,
                      })}
                    />
                    <ArrowDropDownIcon
                      sx={{
                        color: theme => theme.palette.black.main,
                        position: 'relative',
                        left: '6px',
                      }}
                    />
                  </IconButton>
                </>
              </Tooltip>

              <Menu
                sx={{
                  mt: '45px',
                  padding: 0,
                }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                MenuListProps={{
                  sx: {
                    padding: 0,
                  },
                }}
                open={!!anchorElUser}
                onClose={onUserMenuClose}
              >
                {mandants &&
                  mandants.length > 0 &&
                  mandants.map(mandant => (
                    <MenuItem
                      key={`mandant-${mandant.id}-${mandant.name}`}
                      sx={{
                        maxWidth: '197px',
                        maxHeight: '80px',
                        height: '100vh',
                        width: '100vw',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        gap: '16px',
                        cursor: 'pointer',

                        '&.active': {
                          backgroundColor: theme =>
                            theme.palette.appGrey.whiteSmoke,
                          pointerEvents: 'none',
                        },
                      }}
                      {...(activeMandantId &&
                        mandant.id === activeMandantId && {
                          className: 'active',
                        })}
                      onClick={useOnSelectMandant(mandant.id, setAnchorElUser)}
                    >
                      <Typography>{mandant.name}</Typography>

                      <Avatar
                        sx={{
                          width: '40px',
                          height: '40px',
                          borderRadius: 'unset',
                          img: {
                            height: 'auto',
                          },
                        }}
                        src={`data:image/png;base64, ${mandant.logo}`}
                      />
                    </MenuItem>
                  ))}

                {accountSettings.map(setting => (
                  <MenuItem
                    sx={{
                      maxWidth: '197px',
                      maxHeight: '80px',
                      height: '100vh',
                      width: '100vw',
                      display: 'flex',
                      justifyContent: 'flex-end',
                      alignItems: 'center',
                      gap: '16px',
                      cursor: 'pointer',
                    }}
                    key={`setting-${setting.title}`}
                    onClick={useToggleUserMenu(setAnchorElUser, true, setting)}
                  >
                    <Typography textAlign="right" sx={{ width: '100%' }}>
                      {setting.title}
                    </Typography>

                    <LogoutIcon />
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </>
  );
};
export default TopBar;
